import { createHashRouter, Outlet, redirect } from 'react-router-dom';
import { ErrorBoundary } from 'src/modules/common/components/ErrorBoundary/ErrorBoundary';
import { HomePage } from 'src/actuators/home/HomePage.tsx';
import { ActuatorsListPage } from 'src/actuators/list/ActuatorsListPage.tsx';
import { ActuatorAccessoriesPage } from 'src/actuators/accessories/ActuatorAccessoriesPage.tsx';
import { PrefetchUserInput } from 'src/actuators/user-input/PrefetchUserInput.tsx';
import { PrefetchActuatorCheckout } from 'src/actuators/checkout/PrefetchActuatorCheckout.tsx';
import { SharePage } from 'src/actuators/SharePage.tsx';
import { PATHS } from 'src/actuators/common/types/Paths';
import { createChildrenRoute } from 'src/projects/createChildrenRoute.tsx';
import { checkLocalState } from 'src/checkLocalState.ts';

const errorElement = <ErrorBoundary/>;

export const router = () => createHashRouter([
    {
        path: '/',
        loader: () => redirect(PATHS.Home),
    },
    {
        path: PATHS.Home,
        element: <Outlet/>,
        children: createChildrenRoute(<HomePage/>),
        errorElement,
    },
    {
        path: PATHS.UserInput,
        element: <Outlet/>,
        children: createChildrenRoute(<PrefetchUserInput/>),
        errorElement,
        loader: () => checkLocalState(PATHS.Home),
    },
    {
        path: `${PATHS.Actuators}/:page`,
        element: <Outlet/>,
        children: createChildrenRoute(<ActuatorsListPage/>),
        errorElement,
        loader: () => checkLocalState(PATHS.Home),
    },
    {
        path: `${PATHS.Accessories}/:actuatorLabel/:page`,
        element: <Outlet/>,
        children: createChildrenRoute(<ActuatorAccessoriesPage/>),
        errorElement,
        loader: () => checkLocalState(PATHS.Home),
    },
    {
        path: `${PATHS.Checkout}/:actuatorLabel/:page`,
        element: <Outlet/>,
        children: createChildrenRoute(<PrefetchActuatorCheckout/>),
        errorElement,
        loader: () => checkLocalState(PATHS.Home),
    },
    {
        path: PATHS.Share,
        element: <SharePage/>,
        errorElement,
    },
    {
        path: '*',
        loader: () => redirect(PATHS.Home),
    },
]);
